module.exports = __webpack_public_path__ + "img/4f7f1d3.svg";